import { useEffect, useState, useRef } from 'react';
import { postConsultarCargosPorPadron } from 'api/recaudacion';
import { titleize } from 'utils/normalizers';
import { sortCargos } from 'utils/cargos';

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const getAdeudoPadronAsync = async (
  tipoDePadron,
  padronId,
  setLoadingMessage = () => null,
  getPlantillas,
) => {
  const response = await postConsultarCargosPorPadron(tipoDePadron, padronId, false, getPlantillas);
  if (response.detail || response.status) {
    setLoadingMessage(titleize(response.detail || response.status));
    await wait(5000);
    return getAdeudoPadronAsync(
      tipoDePadron,
      padronId,
      setLoadingMessage,
      getPlantillas,
    );
  }
  if (response.cargos) {
    setLoadingMessage();
    return [response.cargos, null];
  }
  setLoadingMessage('No fue posible obtener el adeudo del padrón');
  return [[], 'No fue posible obtener el adeudo del padrón'];
};

export const getAdeudoPadron = async (
  tipoDePadron,
  padronId,
  setLoading,
  setCargos,
  setLoadingMessage,
  normalizeCargos,
  timeoutRef,
  onSuccessCallback,
  onFailCallback,
) => {
  setLoading(true);
  const response = await postConsultarCargosPorPadron(tipoDePadron, padronId);
  if (response.detail || response.status) {
    setLoadingMessage(titleize(response.detail || response.status));
    // eslint-disable-next-line no-param-reassign
    timeoutRef.current = setTimeout(() => getAdeudoPadron(
      tipoDePadron,
      padronId,
      setLoading,
      setCargos,
      setLoadingMessage,
      normalizeCargos,
      timeoutRef,
      onSuccessCallback,
      onFailCallback,
    ), 5000);
  } else if (response.cargos) {
    const _cargos = sortCargos(normalizeCargos
      ? normalizeCargos(response.cargos) : response.cargos);
    setCargos(_cargos);
    if (onSuccessCallback) {
      onSuccessCallback(_cargos);
    }
    setLoading(false);
    setLoadingMessage();
    // eslint-disable-next-line no-param-reassign
    timeoutRef.current = null;
  } else {
    setLoadingMessage('No fue posible obtener el adeudo del padrón');
    setLoading(false);
    if (onFailCallback) {
      onFailCallback();
    }
    setCargos([]);
  }
};

const useAdeudoPadron = (
  tipoDePadron,
  padronId,
  normalizeCargos,
  onSuccessCallback,
  onFailCallback,
) => {
  const timeoutRef = useRef();
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [cargos, setCargos] = useState([]);

  useEffect(() => {
    if (tipoDePadron && padronId) {
      getAdeudoPadron(
        tipoDePadron,
        padronId,
        setLoading,
        setCargos,
        setLoadingMessage,
        normalizeCargos,
        timeoutRef,
        onSuccessCallback,
        onFailCallback,
      );
    } else {
      setCargos([]);
    }
  }, [tipoDePadron, padronId]);

  return [
    loading,
    loadingMessage,
    cargos,
    () => (padronId ? getAdeudoPadron(
      tipoDePadron,
      padronId,
      setLoading,
      setCargos,
      setLoadingMessage,
      normalizeCargos,
      timeoutRef,
      onSuccessCallback,
      onFailCallback,
    ) : () => {}),
  ];
};

export default useAdeudoPadron;
